// Angular
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material';
// RxJS
import { delay } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
	selector: 'kt-remind-delivery-plan',
	templateUrl: './remind-delivery-plan.component.html',
	changeDetection: ChangeDetectionStrategy.Default

})
export class RemindDeliveryPlanComponent implements OnInit {
	constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) { }
	ngOnInit() {}
	public onAction(){ this.data.snackBar.dismiss();}
	public navigate(){
		this.data.router.navigateByUrl(this.data.routerLink);
		this.onAction();
	}
}
